import { Customer_Origin } from "gen/customer/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import {
  BoolFilter,
  CustomPriceRuleValidityFilter,
} from "gen/search/service/service_pb"
import { Tag } from "gen/tag/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

import { tierFilterKey } from "features/pos/customers/CustomersV2/useCustomersFilters/useTierFilter"
import { encodeQueryParam } from "hooks/filters/useWebFilter"

export const CustomerTabs = {
  TRANSACTIONS: "transactions",
  BALANCE: "balance",
  JOBS: "jobs",
  RELATIONSHIP: "relationship",
  CUSTOM_PRICES: "custom-prices",
  SETTINGS: "settings",
} as const
export type CustomerTab = (typeof CustomerTabs)[keyof typeof CustomerTabs]

export function customer(id?: PBUUID, tab?: CustomerTab): WebUrl {
  return {
    pathname: `/pos/customers/${UUID.idString(id)}/${tab ?? CustomerTabs.TRANSACTIONS}`,
    query: {
      ...(tab === CustomerTabs.CUSTOM_PRICES && {
        status: CustomPriceRuleValidityFilter.CPRVF_ACTIVE.toString(),
      }),
    },
  }
}

export function customers(isEcommerceEnabled: boolean): WebUrl {
  return {
    pathname: "/pos/customers",
    query: {
      status: BoolFilter.TRUE.toString(),
      ...(isEcommerceEnabled && {
        origin: Customer_Origin.POS.toString(),
      }),
    },
  }
}

export function jobs(): WebUrl {
  return {
    pathname: "/pos/customers/jobs",
    query: { status: BoolFilter.TRUE.toString() },
  }
}

export function customerContacts(): WebUrl {
  return {
    pathname: "/pos/customers/contacts",
  }
}

export function customerStatementRuns(): WebUrl {
  return {
    pathname: "/pos/customers/statement-runs",
  }
}

export function customerStatements(statementRunId?: PBUUID): WebUrl {
  return {
    pathname: `/pos/customers/statements/${UUID.idString(statementRunId)}`,
  }
}

export function customerStatementsGenerate(): WebUrl {
  return {
    pathname: "/pos/customers/statements/generate",
  }
}

export function customerTier(
  pricingTierIdString?: string,
  isEcommerceEnabled?: boolean
): WebUrl {
  return {
    pathname: "/pos/customers",
    query: {
      status: BoolFilter.TRUE.toString(),
      ...(isEcommerceEnabled && {
        origin: Customer_Origin.POS.toString(),
      }),
      [tierFilterKey]: pricingTierIdString,
    },
  }
}

export function customersWithTag(
  tag: Tag,
  isEcommerceEnabled?: boolean
): WebUrl {
  return {
    pathname: "/pos/customers",
    query: {
      ...(isEcommerceEnabled && {
        origin: Customer_Origin.POS.toString(),
      }),
      tag: encodeQueryParam(
        { key: UUID.idString(tag.id), value: tag.name },
        true
      ),
    },
  }
}
